import React from 'react';
import '../../App.css';

const Loader = () => {
    return ( 
        <div id="loader" classname="d-flex justify-content-center align-items-center flex-column">
            <img src="https://react-pdf.org/images/logo.png" alt="loader" classname="mb-5 App-logo"/>
            <p>Loading ... </p>
        </div>
     );
}
 
export default Loader;